import { render, staticRenderFns } from "./widgetList.vue?vue&type=template&id=6f7c4d17&"
import script from "./widgetList.vue?vue&type=script&lang=js&"
export * from "./widgetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports